import React from 'react'
import { FormProvider } from 'react-hook-form'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { ICarrierApplicationEntityTypes } from 'types/graphqlTypes'
import { CompanyInformationEditModalForm } from './CompanyInformationEditModalForm'
import { useCompanyInformationEditModalForm } from './useCompanyInformationEditModalForm'

interface ICompanyInformationEditModalProps extends Omit<IModalBaseProps, 'modalType'> {
  onConfirm: (data: { entityType: ICarrierApplicationEntityTypes }) => void
  onCancel: () => void
}

export const CompanyInformationEditModal = ({
  onCancel,
  onConfirm,
  open = false,
  ...props
}: ICompanyInformationEditModalProps) => {
  const methods = useCompanyInformationEditModalForm({
    defaultValues: {},
  })

  const { handleSubmit } = methods || {}
  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Submit',
      action: handleSubmit(onConfirm),
      type: 'confirm',
      dataTest: 'confirm-button',
    },
    {
      label: 'Cancel',
      action: () => {
        onCancel()
      },
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
  ]

  return (
    <ModalBase
      dataTest='CompanyInformationEditModal'
      modalType={MODAL_TYPES.form}
      size={6}
      open={open}
      actions={actions}
      title='Company Information'
      {...props}>
      <FormProvider {...methods}>
        <CompanyInformationEditModalForm />
      </FormProvider>
    </ModalBase>
  )
}
